import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  onlineList: [],
  meeting: {},
  enableAudio: true,
  enableVideo: true,
};

export const sliceVideoChat = createSlice({
  name: 'videoChat',
  initialState,
  reducers: {
    setStreams(state, { payload: streams }) {
      state.onlineList = streams;
    },
    addStream(state, { payload: stream }) {
      console.log('ADD STREAM');
      state.onlineList = state.onlineList.filter(
        el => el.createdBy !== stream.createdBy,
      );
      state.onlineList.push(stream);
    },
    updateStream(state, { payload: { streamId, ...stream } }) {
      console.log('UPDATE STREAM', stream);

      const index = state.onlineList.findIndex(el => el._id === streamId);
      if (index >= 0) {
        const oldElem = state.onlineList[index];
        state.onlineList[index] = { ...oldElem, ...stream };
      }
    },
    removeStream(state, { payload: streamId }) {
      console.log('REMOVE STREAM');
      state.onlineList = state.onlineList.filter(
        el => el.meetingId !== streamId,
      );
    },
  },
});

export const { addStream, updateStream, removeStream, setStreams } =
  sliceVideoChat.actions;
export default sliceVideoChat.reducer;
